<div class="terms">
  <ng-container *ngIf="!isLoading; else loadingContent">
    <ngx-extended-pdf-viewer [src]="pdfSrc" height="500px" [showToolbar]="true" [showSidebarButton]="true"
      [showFindButton]="false" [showPagingButtons]="true" [showDrawEditor]="true" [showHighlightEditor]="false"
      [showStampEditor]="false" [showTextEditor]="true" [showZoomButtons]="true" [showPresentationModeButton]="false"
      [showOpenFileButton]="false" [showPrintButton]="true" [showDownloadButton]="true"
      [showSecondaryToolbarButton]="true" [showRotateButton]="undefined" [showRotateCwButton]="false"
      [showRotateCcwButton]="false" [showHandToolButton]="false" [showScrollingButton]="false" [showSpreadButton]="true"
      [showPropertiesButton]="false"></ngx-extended-pdf-viewer>
  </ng-container>

  <!-- Loading Content -->
  <ng-template #loadingContent>
    <app-pol-loader skeletonSize="large" [skeletonRows]="4" skeletonAlignment="aligned"></app-pol-loader>
  </ng-template>

  <div class="signature-section">
    <h2>Signature</h2>
    <p>If you are having trouble viewing the agreement, please <button class="btn-link link"
        (click)="openDocumentPDF(userAgreement)" target="blank">click here</button></p>
    <p>To download the latest version of Adobe Reader, please <a class="click-here" target="#" href="https://get.adobe.com/reader/">click
        here</a></p>
    <div class="form-fields" [formGroup]="formGroup">
      <div class="ods-form-field">
        <label for="name" id="nameLabel">Please enter your name</label>
        <input class="ods-text-input" formControlName="name" id="name" autocomplete="off" />
      </div>
      <div class="ods-form-field">
        <label for="reEnteredName" id="reEnteredNameLabel">Re-enter your name</label>
        <input class="ods-text-input" formControlName="reEnteredName" id="reEnteredName" autocomplete="off" />
      </div>
      
      <div aria-live="polite">
        <div class="errorWrap" *ngIf="(formGroup.get('name').touched) && !formGroup.valid">
          <span class="errorIcon"></span>
          <p *ngIf="formGroup.get('name').errors?.required || formGroup.get('reEnteredName').errors?.required">
            Enter a valid Signature
          </p>
          <p *ngIf="!(formGroup.get('name').errors?.required || formGroup.get('reEnteredName').errors?.required) && formGroup?.errors?.['nameMismatchError']">Signatures must match</p>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ods-button" id="signBtn" (click)="navigateToHome()" [disabled]="!formGroup.valid">Sign</button>
      <button class="ods-button ods-button--companion" (click)="signOut()" id="cancelBtn">Cancel</button>
    </div>
  </div>
</div>